import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { toggleLoader } from "../../shared/actions/setting";
import { getReferencesForRole, updateReferencesOfUser } from "../../utils/mainServices";
import FeatherIcon from "feather-icons-react";
import { useTranslation } from "react-i18next";
import Select from "react-select";
import { USER_TYPES } from "../../utils/Enum";
import {toast} from "react-toastify";
import FormHandler from "../../shared/utils/FormHandler";
import { validateAddDrop } from "../../utils/validation";

const AddDropReferences = ({selectedUserData, onClose, referencesList}) => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const [formErr, setFormErr] = useState("");
  const [allReferences, setAllReferences] = useState([]);
  const [error, setError] = useState(null);
  const roleId = selectedUserData?.userRoleId;

// Save the add/drop
  const saveAddDrop = async () => {
    const userUpdate = {
      id: selectedUserData?.id,
      references: values.references,
    };

    try {
      dispatch(toggleLoader(true));
      await updateReferencesOfUser(userUpdate);
      toast.success("Updated successfully.");
      resetForm(true);
    } catch (error) {
      console.error("Error updating user:", error);
      toast.error("Something went wrong while updating the user.");
    } finally {
      dispatch(toggleLoader(false));
    }
  };
  

  const {
    values,
    errors,
    handleSubmit,
    setValue,
    initForm
  } = FormHandler(saveAddDrop, (values) => validateAddDrop(values, referencesList));


  // Fetch all references based on roleId
  useEffect(() => {
    const fetchReferences = async () => {
      if (!roleId) return;

      try {
        dispatch(toggleLoader(true));
        const data = await getReferencesForRole(roleId);
        setAllReferences(data.content);
      } catch (err) {
        setError(err.message);
      } finally {
        dispatch(toggleLoader(false));
      }
    };

    fetchReferences();
  }, [roleId]);

// Initialize selected references
  useEffect(() => {
    if (!referencesList || referencesList.length === 0) return;

    initForm({
      references: referencesList.map((ref) => ref.id),
    });

  }, []);


  function resetForm(state) {
    onClose(state);
    setFormErr("");
  }


  // Handle selection change
  const handleSelectChange = (selectedOptions) => {    
    setValue({ references: selectedOptions.map((ref) => ref.value) });
    };
  
  return (
    <div className={"sa-popup-bg "}>
      <div className="sa-popup">
        <form className={"sa-modal-box-style"} type="submit">
          <div className="sa-popup-header">
            <span className={"sa-model-heading"}>{`Add/Drop ${USER_TYPES[roleId]}s`}</span>
            <div className="sa-popup-close-icon" onClick={() => resetForm(false)}>
              <FeatherIcon className={"sa-modal-close-icon"} icon={"x"} />
            </div>
          </div>
          <div className="sa-popup-content">
            <div className="col-md-6">
              <div className="form-group m-b-16">
                <label htmlFor="email">{USER_TYPES[roleId]}</label>
                <Select
                  options={allReferences.map((ref) => ({ value: ref.id, label: ref.name }))}
                  isMulti
                  value={values.references && Array.isArray(values.references) ? values.references.map(refId => {
                    const ref = allReferences.find(reference => reference.id === refId);
                    return ref ? { value: ref.id, label: ref.name } : null;
                  }).filter(ref => ref !== null) : []}
                  onChange={handleSelectChange}
                  isSearchable={true}
                  className="basic-multi-select"
                  classNamePrefix="select"
                  menuPortalTarget={document.body}
                  styles={{
                    menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                  }}
                />
                {errors.references && <p className="warning-input-msg">{errors.references}</p>}
              </div>
            </div>
          </div>
          {formErr && <div className={"login-warning-msg"}>{formErr}</div>}
          <div className="sa-popup-btn">
            <button
              className="sa-popup-secondary-btn-style sa-popup-cancel-btn-style"
              type="button"
              onClick={() => resetForm(false)}
            >
              {t("button.CANCEL")}
            </button>
            <button type="submit" className="sa-popup-secondary-btn-style" onClick={handleSubmit}>
               {t(`button.SAVE`)}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default AddDropReferences;
